import { ApisauceInstance, create } from 'apisauce';
import { ApiConfig, DEFAULT_API_CONFIG } from './api-config';
import axios, { AxiosRequestConfig } from 'axios';
import { isValidToken, nowSec, setSession, tokenDestroy } from 'src/auth/util';
import { ROOT_PATH } from 'src/routes/paths';
const { REACT_APP_API_URL } = process.env;

/**
 * Manages all requests to the API.
 */
export class Api {
  /**
   * The underlying apisauce instance which performs the requests.
   */
  //@ts-ignore
  apisauce: ApisauceInstance;

  /**
   * Configurable options.
   */
  config: ApiConfig;

  /**
   * Creates the api.
   *
   * @param config The configuration to use.
   */
  constructor(config: ApiConfig = DEFAULT_API_CONFIG) {
    this.config = config;
  }

  /**
   * Sets up the API.  This will be called during the bootup
   * sequence and will happen before the first React component
   * is mounted.
   *
   * Be as quick as possible in here.
   */
  setup() {
    // construct the apisauce instance
    this.apisauce = create({
      baseURL: this.config.url,
      timeout: this.config.timeout,
      headers: {
        Accept: 'application/json',
        Authorization: sessionStorage.getItem('accessToken')
          ? 'Bearer ' + sessionStorage.getItem('accessToken')
          : '',
      },
      withCredentials: true,
    });

    /** request interceptor */
    this.apisauce.axiosInstance.interceptors.request.use(
      async (config: AxiosRequestConfig) => {
        /** 토큰 재발급 */
        const accessToken = sessionStorage.getItem('accessToken');
        if (accessToken) {
          if (!isValidToken(accessToken)) {
            const param = {
              refreshToken: sessionStorage.getItem('refreshToken')
            }
            const response = await axios.post(
              REACT_APP_API_URL + `user/refreshToken`, param);
            if (response.data.resultCode === 'S') {
              const new_token = JSON.parse(response.data.data);
              setSession(new_token.access_token, new_token.refresh_token, nowSec() + new_token.expires_in);
            } else if (response.data.resultCode === 'F') {
              tokenDestroy();
              localStorage.setItem('auth_error', response.data.message);
              window.location.replace(ROOT_PATH);
              return;
            }
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  testSetup() {
    // construct the apisauce instance
    this.apisauce = create({
      baseURL: this.config.url,
      timeout: this.config.timeout,

      headers: {
        Accept: 'application/json',
      },
    });
  }

  storeTestSetup() {
    // construct the apisauce instance
    this.apisauce = create({
      baseURL: 'https://kbn_mock_route.surfinn.kr',
      timeout: this.config.timeout,

      headers: {
        Accept: 'application/json',
      },
    });
  }
}
